const TITLE_SUFFIX = " | Matt Rebeiro";

export function truncateMetaDescription(text: string, maxLen = 155): string {
  const t = text.replace(/\s+/g, " ").trim();
  if (t.length <= maxLen) return t;
  const cut = t.slice(0, maxLen - 1);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > 40 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}

export type DocumentMetaOptions = {
  title: string;
  description: string;
  /** If true, `title` is used as the full document title (no suffix). */
  fullTitle?: boolean;
  noindex?: boolean;
};

function ensureMetaDescription(): HTMLMetaElement {
  let el = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "description");
    document.head.appendChild(el);
  }
  return el;
}

function ensureRobotsMeta(): HTMLMetaElement {
  let el = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", "robots");
    document.head.appendChild(el);
  }
  return el;
}

/** Apply title, meta description, and optional noindex. */
export function applyDocumentMeta(opts: DocumentMetaOptions): void {
  document.title = opts.fullTitle ? opts.title : `${opts.title}${TITLE_SUFFIX}`;

  const desc = ensureMetaDescription();
  desc.setAttribute("content", truncateMetaDescription(opts.description));

  const robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (opts.noindex) {
    ensureRobotsMeta().setAttribute("content", "noindex, nofollow");
  } else if (robots) {
    robots.remove();
  }
}

